import state from './mediaState'
import mutations from './mediaMutations'
import getters from './mediaGetters'
import actions from './mediaActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
